import { request } from '../request'

export const units = {
  changeUserUnits: function (units: string) {
    return request.post('units/changeUserUnits', { units })
  }
}
